import { defaultsFromSchema } from './schema';

export interface Preset {
  id: string;
  name: string;
  description?: string;
  values: Record<string, string | number | boolean>;
}

const base = defaultsFromSchema();

export const BUILTIN_PRESETS: Preset[] = [
  {
    id: 'bambu-0.20-standard',
    name: '0.20mm Standard (Bambu)',
    description: 'P1S 0.4 nozzle · Bambu PLA Basic defaults',
    values: { ...base, layer_height: 0.2, initial_layer_print_height: 0.2 },
  },
  {
    id: 'bambu-0.12-fine',
    name: '0.12mm Fine',
    values: {
      ...base,
      layer_height: 0.12,
      initial_layer_print_height: 0.2,
      outer_wall_speed: 150,
      top_shell_layers: 7,
    },
  },
  {
    id: 'bambu-0.28-draft',
    name: '0.28mm Draft',
    values: {
      ...base,
      layer_height: 0.28,
      initial_layer_print_height: 0.28,
      top_shell_layers: 3,
      bottom_shell_layers: 2,
    },
  },
  {
    id: 'strength',
    name: 'Strength',
    values: {
      ...base,
      wall_loops: 4,
      sparse_infill_density: 40,
      sparse_infill_pattern: 'gyroid',
      top_shell_layers: 6,
      bottom_shell_layers: 5,
    },
  },
  {
    id: 'petg',
    name: 'PETG Generic',
    values: {
      ...base,
      filament_type: 'PETG',
      nozzle_temperature: 250,
      nozzle_temperature_initial_layer: 250,
      fan_min_speed: 30,
      fan_max_speed: 60,
      filament_flow_ratio: 0.95,
      filament_density: 1.27,
      filament_max_volumetric_speed: 12,
    },
  },
];

const LS_KEY = 'p1s-slicer-user-presets';

export function loadUserPresets(): Preset[] {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return [];
    return JSON.parse(raw) as Preset[];
  } catch {
    return [];
  }
}

export function saveUserPreset(preset: Preset): Preset[] {
  const all = loadUserPresets().filter((p) => p.id !== preset.id);
  all.push(preset);
  localStorage.setItem(LS_KEY, JSON.stringify(all));
  return all;
}

export function deleteUserPreset(id: string): Preset[] {
  const all = loadUserPresets().filter((p) => p.id !== id);
  localStorage.setItem(LS_KEY, JSON.stringify(all));
  return all;
}
